/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![QuoteIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAB90lEQVR4nO2VP0hVcRTHr6Y4JA4OCYWgkyg1txQPA+Hm83fOudDvnvPyjfagyUKCGuK1uITSZotTKjQ2BG0J0iiCIhGkIE5iUCBRUaRxnpX3z+/e+3D2Bz+4w+ec7/n7u553dk57ECsTBvm5tbaziK3X661AMm2QH+t3oXMgfgAkR3oN8YYxtj/XOfLCfx75te+Pd2U6NyRVIDn8ZwCNy58A5GpGMDNxVkXkfblsL6VgxNtXAPl70gAamcgjRzChi9UAx4hvxmBr7TkgXk/BqII86XleS8y5kR4g/pzmZR+xYhypyp101PxljCrXnKVBmXNE/hGR+5yNMihb8TryT0S+7nIeBNULQPIjHTn3unjPBHLDEc20E1YeZSrFg9zycgxmHQIvDPFda213iid5m2B/AfEzCMJx3/c70gIkKxnTcKR9QKyMRvAWQ3KQxQPydjkIL8cEgHgv04Aac/0NwA40WJCLeezfkd4dGamejwgkGuaMTOaOBexQIXucee1EIGO5EgaryhLxYDMCQDIfFdgpNuBNZbXpTWWAshht8ssmSvQqwn8oFuAnJxlAONxE48LIWN8rcP5be5Xchac5zpeib1GpVGoD5Dc55XzoXjh9HVHeAfFXHU1DvKbL5vqJ1Gq1dgC5r/8LnULdDUOy7Hzozo6Xc/4A/d8JfM/ins0AAAAASUVORK5CYII=)
 */
export const QuoteIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M2.35 19.44A4.75 4.75 0 0 0 6.07 21c1.43 0 2.58-.43 3.44-1.3.9-.9 1.35-2.06 1.35-3.5 0-1.43-.43-2.58-1.3-3.45a4.63 4.63 0 0 0-3.5-1.34c.6-1.6 1.99-3.1 4.16-4.49a.8.8 0 0 0 .1-1.3l-2.68-2.2a.76.76 0 0 0-.98 0C2.89 6.78 1 10.64 1 15.02c0 1.9.45 3.38 1.35 4.42ZM14.16 19.44A4.75 4.75 0 0 0 17.88 21c1.43 0 2.58-.43 3.45-1.3.9-.9 1.34-2.06 1.34-3.5 0-1.43-.43-2.58-1.3-3.45a4.63 4.63 0 0 0-3.5-1.34c.6-1.6 1.99-3.1 4.16-4.49a.8.8 0 0 0 .1-1.3l-2.68-2.2a.76.76 0 0 0-.98 0c-3.77 3.36-5.66 7.22-5.66 11.6 0 1.9.45 3.38 1.35 4.42Z"
        className={colorClass}
      />
    </svg>
  );
};
